// const BASE_URL = "http://192.168.1.14:5000/api";
// const BASE_URL = "https://metal-trade.onrender.com/api";
const BASE_URL = "https://backend.meta-trade.in/api";

export default BASE_URL;
